import React, { useRef, useEffect, useState } from "react";
import { useParams, useSearchParams, useLocation } from "react-router";

export function useCsvParameters(excludedFields = []) {
    const [searchParams, setSearchParams] = useSearchParams();
    // Get an iterator for the URLSearchParams object.
    const entries = searchParams.entries();
    const location = useLocation();

    const result = {};

    // Loop through the URLSearchParams object and add each key/value
    for (const [key, value] of entries) {
        if (excludedFields.includes(key)) {
            result[key] = value;
        } else {
            // Split comma-separated values into an array.
            if (value.includes("-")) {
                result[key] = value.split("-");
            } else {
                result[key] = [value];
            }
        }

        // If a key does not have a value, delete it.
        if (!value) {
            delete result[key];
        }
    }
    const addValue = (param, value) => {
        let valCSV = searchParams.get(param);
        let values = valCSV ? valCSV.split("-") : [];
        values = values.filter((e) => e != value);
        values.push(value);
        values = values.sort();
        valCSV = values.join("-");
        searchParams.set(param, valCSV);

        setSearchParams(searchParams);
    };

    const removeValue = (param, value) => {
        let valCSV = searchParams.get(param);
        let values = valCSV ? valCSV.split("-") : [];
        values = values.filter((e) => e != value);
        valCSV = values.join("-");
        searchParams.set(param, valCSV);

        setSearchParams(searchParams);
    };
    const setValue = (param, value, replace) => {
        searchParams.set(param, value);
        if (replace === true) {
            setSearchParams(searchParams, { replace: true, state: location.state });
        } else {
            setSearchParams(searchParams, { state: location.state });
        }
    };

    const deleteValue = (param) => {
        searchParams.delete(param);
        setSearchParams(searchParams, { state: location.state });
    };

    return [result, addValue, removeValue, setValue, deleteValue];
}
